import { gql } from '@apollo/client';

export const UNLOCK_LOCKED_SEGMENT_V2 = gql`
  mutation UnlockLockedSegmentV2($input: UnlockSegmentInputV2!) {
    unlockLockedSegmentV2(input: $input) {
      customerSegmentUid
    }
  }
`;
